import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { Helmet } from 'react-helmet-async';
import './DocModal.css';

interface DocModalProps {
  isOpen: boolean;
  onClose: () => void;
  docName: string; // e.g., 'privacy-policy'
  title: string;
}

const DocModal: React.FC<DocModalProps> = ({ isOpen, onClose, docName, title }) => {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (isOpen && docName) {
      setLoading(true);
      fetch(`/docs/${docName}.md`)
        .then(res => {
          if (!res.ok) throw new Error("Failed to load document");
          return res.text();
        })
        .then(text => {
          setContent(text);
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setContent("Error loading document.");
          setLoading(false);
        });
    }
  }, [isOpen, docName]);

  if (!isOpen) return null;

  const docDescription = content ? content.slice(0, 160).replace(/[#*`]/g, '').trim() + '...' : `Read our ${title} guide on Smartgeotag.ai`;

  return (
    <>
      <Helmet>
        <title>{title} | Smartgeotag.ai</title>
        <meta name="description" content={docDescription} />
        <meta property="og:title" content={`${title} - Smartgeotag.ai`} />
        <meta property="og:description" content={docDescription} />
        <link rel="canonical" href={`https://smartgeotag.ai/guide/${docName}`} />
      </Helmet>
      <div className="doc-modal-overlay" onClick={onClose}>
        <div className="doc-modal-content" onClick={e => e.stopPropagation()}>
          <button className="doc-modal-close" onClick={onClose}>&times;</button>
          <div className="doc-modal-body">
            {loading ? <p>Loading...</p> : <ReactMarkdown>{content}</ReactMarkdown>}
          </div>
        </div>
      </div>
    </>
  );
};

export default DocModal;
